export default function bookingDetails() {
    return {
        restrict: "E",
        scope: {
            bp: "=",
        },

        template: require("./template.html"),

        controller: function ($scope, $filter, Basket) {
            $scope.activity = Basket.getBookingActivity();

            // This directive is inside the Loop of bookings Days
            $scope.isCollapsed = false;

            // $scope.sCombinedNames = $scope.bpsByDate.collected.sCombinedHouseAndParent;
            // $scope.combinedHourAndPrice = $scope.bpsByDate.collected.hourCollection +' ('+ $scope.bpsByDate.collected.priceCollection +' )'

            $scope.setDateString = function () {
                var fromTime = $filter("date")($scope.bp.start, "HH:mm");
                var ToTime = $filter("date")($scope.bp.end, "HH:mm");

                $scope.timeString = fromTime + " - " + ToTime;
            };
            $scope.setDateString();
        },
    };
}
